import { render, staticRenderFns } from "./ExistingTestimonial.vue?vue&type=template&id=50af20a4&"
import script from "./ExistingTestimonial.vue?vue&type=script&lang=js&"
export * from "./ExistingTestimonial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports